export default __webpack_public_path__ + "static/media/png-icon.132f4ff0.svg";